import { SortOrder } from '@/store/types/general.types';
import {
  MyjbiGroupType,
  MyjbiGroupUserAttributeSpec
} from '../../../../jbi-shared/types/myjbi-group.types';
import { EventStatus, ImageStatus } from './admin.types';
import { GroupUserAttributeWithValue } from './group-user-attribute.types';

interface AttributeTypeDto {
  id?: number | null;
  name: string;
  slug?: string;
}

interface AttributeSpecDto {
  id?: number | null;
  groupId?: number;
  attributeType: AttributeTypeDto;
  required: boolean;
}

interface AgreementDto {
  id?: number;
  groupId?: number;
  fileUri: string;
  fileName: string;
}

interface UserAttributesDto {
  attributeType: {
    id?: number;
    name: string;
    slug?: string;
  };
  value: string;
}

export interface UserAttributesStringInputOption {
  id?: number | null;
  name: string;
  slug: string;
}

export interface UserAttributesMultiSelectOption {
  id?: number | null;
  name: string;
  slug: string;
  isLocked: boolean;
}

export interface ProtectedGroupTypes {
  id: number;
  name: string;
  slug: string;
  group_id?: number;
  protected_group_type_id?: number;
}

export interface ProtectedGroupData {
  isProtected: boolean;
  protectedGroupType?: ProtectedGroupTypes | null;
}

export interface CreateNewGroupRequestPayload {
  name: string;
  parentPath?: string;
  maxGroupSize?: number;
  attributesSpecs: MyjbiGroupUserAttributeSpec[];
  agreements: AgreementDto[];
  userAttributesArr: GroupUserAttributeWithValue[][] | [];
  types: string[] | [];
  notify?: boolean;
  emailDomains?: string[];
  protectedGroup?: ProtectedGroupData | null;
}

export interface CreateNewGroupResponsePayload {
  id: number;
  name: string;
  path: string;
}

export interface AddMembersToGroupRequestPayload {
  groupId: number;
  userAttributesArr: GroupUserAttributeWithValue[][] | [];
  notify: boolean;
}

export interface AddMembersToGroupErrorResponsePayload {
  id: number;
  name: string;
  startAt: string;
  endAt: string;
  seats: number;
  groupMemberCount: number;
  groupId: number;
  groupProductId: number;
  groupProductName: string;
  groupName: string;
}

export interface FilteredGroupMemberParamsPayload {
  [s: string]: string | number;
}

export interface UpdateGroupMemberRequestPayload {
  groupId: number;
  userId: number;
  userAttributesArr: GroupUserAttributeWithValue[][] | [];
}

export interface DeleteGroupMemberRequestPayload {
  groupId: number;
  userId: number;
}

export interface UpdateGroupRequestPayload {
  groupId: number;
  name: string;
  parentPath?: string;
  maxGroupSize?: number;
  attributesSpecs: MyjbiGroupUserAttributeSpec[];
  agreements: Array<Partial<AgreementDto>>;
  userAttributesArr: GroupUserAttributeWithValue[][] | [];
  types: MyjbiGroupType[];
  emailDomains: string[];
  emailDomainsNotify: boolean;
  removedEmailDomains: RemoveEmailDomainsPayload[];
  removedMemberIds: number[];
}

export interface CreateNewPrimaryOrgResponse {
  groupId: number;
  groupCreationSuccess: boolean;
}

export interface RemoveEmailDomainsPayload {
  tag: string | null;
  notify: boolean;
}

export interface ResendEmailNotificationToGroupMemberPayload {
  groupId: number;
  userId: number;
}

export interface MasterGroupsResponseDTO {
  id: number;
  name: string;
}

export interface JbicGroupParams {
  legalName?: string;
  region?: string;
  country?: string;
  status?: string;
  limit?: number;
  page?: number;
  sortColumn?: string;
  sortOrder?: SortOrder;
}

export interface JbicGroups {
  id: number;
  name: string;
  path: string;
  max_group_size: number;
  created_at: string;
  updated_at: string;
  deleted_at: null | string;
  memberCount: number;
  region: string;
  country: string;
  pendingApprovalCount: number;
}

export enum JbicGroupStatus {
  ALL = 'ALL',
  APPROVED = 'APPROVED',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL'
}

export interface JbicGroupListColumns {
  groupId: number;
  legalName: string;
  path: string;
  region: string;
  country: string;
  pendingApprovalCount: number;
  uniqueMembersCount: number;
}

export interface JbicChangeRequestDTO {
  groupIds: number[];
}

export interface JbicChangeRequest {
  groupId: number;
  entityName: string;
  eventPendingApprovalCount: number;
  imagePendingApprovalCount: number;
}

export interface JbicChangeRequestListColumns {
  id: number;
  entityName: string;
  galleryRequests: string;
  eventRequests: string;
  lastUpdatedDate: string;
}

export interface JbicChangeRequestEntityFilterOptions {
  status: EventStatus | ImageStatus;
  requestedOn?: Date;
  requestedBy?: string;
  limit: number;
  page: number;
  sortColumn: string;
  sortOrder: SortOrder;
}
